import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { ISendCallsSchema } from "../../Schemas/SendCalls";

interface Filter extends IFilterSchema {
  column: SendCallsListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: SendCallsListColumnSortable;
}

export enum SendCallsListColumnFilterable {
  ID = "id",
  VOICE_BROADCAST_ID = "voice_broadcast_id",
  VOICE_BROADCAST_ID_NUMBER = "voice_broadcast_number_id",
}
export enum SendCallsListColumnSortable {
  ID = "id",
  CREATED_AT = "created_at",
}

export interface SendCallsListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface SendCallsListResponseBody extends IResponseBody {
  data: {
    send_calls: ISendCallsSchema[];
    total: number;
  };
}

export class SendCallsListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/send-calls`;
  }

  async list(
    queryStrings?: SendCallsListQueryString
  ): Promise<SendCallsListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
